import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO, columnWidth, WhereCondition } from '../icd10/icd10.model';
import { GetSftpBO, SftpEventBo } from './sftp.modal';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonApiService } from 'src/app/commonapiservice';
// import { emailValidator } from 'src/app/jobportal/job-portal-register/job-portal-register.component';
@Component({
  selector: 'app-sftp',
  templateUrl: './sftp.component.html',
  styleUrls: ['./sftp.component.scss']
})
export class SftpComponent implements OnInit {
  CompanyDataList: any = [];
  id: number = 0;
  type: string = "";
  conditionlist: WhereCondition[] = [];
  @Input() SFTPRelation: SftpEventBo;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridsftp') public gridsftp: GridComponent;
  SFTPBo: GetSftpBO = new GetSftpBO();
  SFTPData: any = [];
  arraycol: any = [];
  ColumnArray: columnWidth[];
  public filterSettings: object;
  initialPage: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public SFTPDataGridList: Observable<DataStateChangeEventArgs>;
  SFTPForm: FormGroup;
  FilterStatusList: any = [];
  FS:any=true;
  StatusList: any = [];
  dropdata: any = ["ACTIVE", "INACTIVE"];
  constructor(public CommonAPI: CommonApiService, private fb: FormBuilder, public global: GlobalComponent, public toastrService: ToastrService,) {
    this.SFTPDataGridList = CommonAPI;
    this.SFTPForm = fb.group({
      id: "00000000-0000-0000-0000-000000000000",
      userName: ['', Validators.required],
      Password: ['', [Validators.required]],
      Email:['',Validators.compose([this.global.emailRegexValidator()])],
      isActive: [true, [Validators.required]]
    });
  }
  ngOnInit(): void {
    this.filterSettings = { type: 'Menu' };
    let pag = 10;
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    this.StatusList = [{
      "Key": true,
      "Value": "ACTIVE"
    },
    {
      "Key": false,
      "Value": "INACTIVE"
    },
    ]
    this.FilterStatusList = [
      {
        "Key": null,
        "Value": "ALL"
      },
      {
      "Key": true,
      "Value": "ACTIVE"
    },
    {
      "Key": false,
      "Value": "INACTIVE"
    },
    ]
    this.getSFTPFilter();
  }
  //........................................SaveorUpdateSFTP...........................................................
  SaveorUpdateSFTP() {
    let save = JSON.parse(JSON.stringify(this.SFTPForm.value));
    save.isActive = JSON?.parse(this.SFTPForm?.value?.isActive);
    let url = this.SFTPForm.value.id == "00000000-0000-0000-0000-000000000000" ? "api/SFTPDetail/SaveSFTPCredential?" : "api/SFTPDetail/UpdateSFTPCredential?"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(save, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (this.SFTPForm.value.id == "00000000-0000-0000-0000-000000000000") {
        this.toastrService.success(
          "SFTP saved successfully!"
        );
      }
      else {
        this.toastrService.success(
          "SFTP updated successfully!"
        );
      }
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      this.clearField();
      this.getSFTPFilter();
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      });
  }
  //........................................validatePassword...........................................................
  validatePassword(control: AbstractControl) {
    if (control.value) {
      const pattern = /(?=.*[A-Z])(?=.*[a-z])(?=.*\W).{8,18}$/;
      if (!control.value.match(pattern) && control.value !== '') {
        return { invalidPassword: true };
      }
      return null;
    }
  }
  //........................................getDetails...........................................................
  getDetails(data) {
    let isActive= data?.isActive=="ACTIVE"?true:false 
    this.SFTPForm.controls["id"].setValue(data.id);
    this.SFTPForm.controls["userName"].setValue(data.username);
    this.SFTPForm.controls["Password"].setValue(data.password);
    this.SFTPForm.controls["Email"].setValue(data.email);
    this.SFTPForm.controls["isActive"]?.setValue(data.isActive);
    this.SFTPForm.controls.Email?.setErrors(null);
  }
  getDeleteList(list) {
    this.SFTPForm.controls["id"].setValue(list.id);
  }  //................................................clearField.........................................................
  clearField() {
    this.SFTPForm.reset();
    this.SFTPForm = this.fb.group({
      id: "00000000-0000-0000-0000-000000000000",
      userName: ['', Validators.required],
      Password: ['', [Validators.required]],
      Email:['',Validators.compose([this.global.emailRegexValidator()])],
      isActive: [true, [Validators.required]]
    });
    document.getElementById("openCreateorUpdateSFTP").click();
  }
  //.................................................getSFTPFilter............................................
  getSFTPFilter() {
    let responseData =
    {
      result: "result",
      count: "count",
    }
    let url = "api/SFTPDetail/GetSFTPCredentials"
    this.SFTPBo.isActive=JSON.parse(this.FS);
    this.CommonAPI.outputValues(url, this.SFTPBo, responseData, "");
    let count = 0;
    this.SFTPDataGridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.SFTPData = data.result;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        // this.getColumnwidth();
      }
      if (data != null && data.result.length > 15) {
        this.gridsftp.height = '500';
      }
      else {
        this.gridsftp.height = 'auto';
      }
    })
  }
  //......................................................onResizeSFTP....................................................
  onResizeSFTP(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.gridsftp.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    //   this.SaveColumnwidth();
    }
  }
  //..............................................onActionCompleteSFTP.................................................
  public onActionCompleteSFTP(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridsftp.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].SFTP.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].SFTP.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].SFTP.ShowColumns.length != count1 || this.arraycol[0].SFTP.HideColumns.length != count) {
            this.arraycol[0].SFTP.ShowColumns = showarr;
            this.arraycol[0].SFTP.HideColumns = hidearr;
            // this.SaveColumnwidth();
          }
        }
      }
    }
    this.SFTPBo.currentpageno = this.gridsftp.pagerModule.pagerObj.currentPage;
    this.SFTPBo.pageitem = this.gridsftp.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.SFTPBo.type = args.columnType;
    }


  }
  //..............................................dataStateChangeSFTP.................................................
  public dataStateChangeSFTP(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.SFTPBo.orderColumn = state.sorted[0].name;
        this.SFTPBo.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.SFTPBo.field = state.action.currentFilterObject.field;
      this.SFTPBo.matchCase = state.action.currentFilterObject.matchCase;
      this.SFTPBo.operator = state.action.currentFilterObject.operator;
      this.SFTPBo.value = state.action.currentFilterObject.value;
      this.SFTPBo.value = state.action.currentFilterObject.value;
      this.SFTPBo.field = state.action.currentFilterObject.field;
      this.SFTPBo.matchCase = state.action.currentFilterObject.matchCase;
      this.SFTPBo.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.SFTPBo.field = "userName";
        this.SFTPBo.matchCase = false;
        this.SFTPBo.operator = "startswith";
        this.SFTPBo.value = "";
        this.SFTPBo.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.getSFTPFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].SFTP.Pagesize != state.take) {
          this.arraycol[0].SFTP.Pagesize = state.take
        }
      }
    //   this.SaveColumnwidth();
    }
  }
  //.....................................................showSFTP..............................................
  showSFTP() {
    this.gridsftp.columnChooserModule.openColumnChooser(200, 50);
  }
  //.....................................................SaveColumnwidth..............................................
  SaveColumnwidth() {
    this.arraycol[0].SFTP.Columns = this.ColumnArray;
    this.arraycol[0].SFTP.Pagesize = this.gridsftp.pageSettings.pageSize;

    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.getColumnwidth();
    });
  }
  //.....................................................getColumnwidth..............................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].SFTP.Columns;
    let showcol = this.arraycol[0].SFTP.ShowColumns;
    let hidecol = this.arraycol[0].SFTP.HideColumns
    this.gridsftp.showColumns(showcol);
    this.gridsftp.hideColumns(hidecol);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.gridsftp.pageSettings.pageSize = this.arraycol[0].SFTP.Pagesize;
    this.ColumnArray.forEach(element => {
      // Client
      if (element.column == 'User Name') {
        const column = this.gridsftp.getColumnByField('username');
        column.width = element.width;
        this.gridsftp.refreshHeader();
      }
      if (element.column == 'Email') {
        const column = this.gridsftp.getColumnByField('email');
        column.width = element.width;
        this.gridsftp.refreshHeader();
      }
      
      // Action
      if (element.column == 'Actions') {
        const column2 = this.gridsftp.getColumnByUid('action');
        column2.width = element.width;
        this.gridsftp.refreshHeader();
      }
    });
  }
  DeleteSFTPCredentials() {
    let params = new URLSearchParams();
    params.append("SFTPCredentialId", this.SFTPForm.value.id);
    let url = "api/SFTPDetail/DeleteSFTPCredential?";
    this.CommonAPI.DeleteFunctionForPostHttpWthParams(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('closeModal').click();
      this.toastrService.success('Deleted successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.getSFTPFilter();
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    });

  }
  //..................................................CancelDelete.......................................
  CancelDelete() {
    document.getElementById('closeModal').click();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
